import InputField from "components/fields/InputField";
import { useState } from "react";
import { handleLogin } from "actions/actions";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

export default function SignIn() {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleValidation = () => {
    const errors = { phone: "", password: "" };
    let isValid = true;

    if (!phone) {
      errors.phone = "رقم الهاتف مطلوب";
      isValid = false;
    }

    if (!password) {
      errors.password = "كلمة المرور مطلوبة";
      isValid = false;
    }

    setError(errors);
    return isValid;
  };

  const handleSignIn = async (e) => {
    e.preventDefault();

    if (!handleValidation()) return;
    setIsSubmitting(true);

    const response = await handleLogin(phone, password);

    if (response.success) {
      toast.success(response.success);
      Cookies.set("token", response.token);
      navigate("/");
    } else {
      toast.error(response.error || "حدث خطأ يرجي المحاولة لاحقًا");
    }

    setIsSubmitting(false);
  };

  return (
    <div
      dir="rtl"
      className="mt-10 mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center"
    >
      <form className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:max-w-[420px] lg:pl-0">
        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
          تسجيل الدخول
        </h4>
        <p className="mb-9 ms-1 text-base text-gray-600">
          أدخل رقم الهاتف وكلمة المرور لتسجيل الدخول
        </p>
        <InputField
          variant="auth"
          extra="mb-3"
          label="رقم الهاتف*"
          placeholder="مثال: 01012345678"
          id="phone"
          type="text"
          error={error?.phone}
          onChange={(e) => setPhone(e.target.value)}
        />

        <InputField
          variant="auth"
          extra="mb-3"
          label="كلمة المرور*"
          placeholder="8 خانات على الأقل"
          id="password"
          type="password"
          error={error?.password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button
          type="submit"
          disabled={isSubmitting}
          onClick={handleSignIn}
          className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 disabled:cursor-not-allowed disabled:opacity-50 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
        >
          {isSubmitting ? "جاري الدخول..." : "تسجيل الدخول"}
        </button>
      </form>
    </div>
  );
}
